import { complement, pick, prop } from 'ramda';
import { useParams } from 'react-router-dom';
import { storageService } from 'js/services/storage.service';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import * as hooks from './hooks';

export const useDetectLanguage = () => {
    const { pathLang } = useParams();
    const { lang: userLang } = useUserSelector(pick(['lang']));
    const isWaiting = useAppSelector(complement(prop('allowedLocales')));
    const storageLang = storageService.local.getItem('userLang');

    hooks.usePathLang({ isWaiting, pathLang, userLang });
    hooks.useStorageLang({ isWaiting, pathLang, userLang, storageLang });
    hooks.useBrowserLang({ isWaiting, pathLang, userLang, storageLang });
};
